import * as Yup from 'yup';
// Importa o método customizado de validação de email sem acentos
import '../fire-insurance-budget-form/validators/constants';

export const estateValidationSchema = Yup.object().shape({
    currentEmail: Yup.string()
      .isValidEmailWithoutAccents().required('Campo Obrigatório.'),
    email: Yup.string()
      .isValidEmailWithoutAccents().required('Campo Obrigatório.'),
});
